<template>
    <modal name="viewCardsModal" width="85%" height="auto" :scrollable="true" class="pt-3 pb-3">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title dashboard-card-title">View Card Deck</h4>
                <button type="button" class="btn-close" data-dismiss="modal" aria-hidden="true"
                        @click="$modal.hide('viewCardsModal')"></button>
            </div>
            <div class="modal-body" style="padding: 64px; padding-top: 40px" v-if="cardDeck">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <div class="title pb-1">{{ cardDeck.title }}</div>
                        <div class="card-deck-author">
                            <user-avatar :user="cardDeck.owner"></user-avatar>
                            <span class="me-2">
                                Created on {{ cardDeck.created_at | moment('DD MMM YYYY')}}<br>
                                by <b>{{ cardDeck.owner ? cardDeck.owner.name : '' }}</b>
                            </span>
                            <span class="card-deck-badge" v-if="cardDeck.cards">
                                {{  cardDeck.cards.length }} {{ cardDeck.cards === 1 ? 'card' : 'cards'}}
                            </span>
                            <span class="card-deck-badge primary">{{ cardDeck.category ? cardDeck.category.label : '' }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-1 justify-content-end">
                        <btn v-if="!hideBtn" class="btn btn-primary me-2" @click="$emit('onAssignCardDeck')">Share with Heroes</btn>
                        <btn v-if="!hideBtn" class="btn btn-outline-light" :class="{'btn-light': showHistory}" @click="showHistory = !showHistory"><inline-svg class="me-1" src="/assets/img/icons/clock.svg"></inline-svg> Activity History</btn>
                    </div>
                </div>
                <div class="divider --top-20"></div>
                <div class="cards-list-wrapper">
                    <div class="cards-list mt-2">
                        <card v-for="card in cardDeck.cards" :key="card.id" :card="card"></card>
                    </div>
                    <div class="activity-history" v-if="showHistory" :class="{'loading': loading.history}">
                        <div class="activity-history__title">Activity History
                            <span class="activity-history__close" @clic="showHistory = false"><inline-svg src="/assets/img/icons/x-close.svg"/></span>
                        </div>
                        <div v-if="history.length > 0">
                            <div class="activity-history__item" v-for="item in history">
<!--                                <span class="activity-history__item-status"></span>-->
                                <user-avatar id="avatar"
                                             :user="item.user"
                                             displayName="true"
                                             :time-ago="$options.filters.momentAgo(item.date)"
                                             :subtitle="item.content">
                                </user-avatar>
                            </div>
                        </div>
                        <div v-else>
                            No activity history
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>

import UserAvatar from "@/components/UserAvatar.vue";
import Card from "@/components/Card.vue"

export default {
    name: 'CardDeckCardsModal',
    components: {UserAvatar, Card},
    props: ['cardDeck', 'hideBtn'],
    data() {
        return {
            loading: {
                history: false,
            },
            user: {},
            showHistory: false,
            history: [],
        };
    },
    watch: {
        cardDeck(val) {
            this.showHistory = false;
            this.history = [];
        },
        showHistory(val) {
            if (val) {
                this.getActivityHistory()
            }
        },
    },
    methods: {
        getActivityHistory() {
            this.loading.history = true;
            this.$http.post('/deck/activity-history', { deck_id: this.cardDeck.id})
                .then(function (res) {
                    this.loading.history = false;
                    this.history = res.data.data.data
                }).catch(() => {
                    this.loading.history = false;
                });
        },
    }
};
</script>
